module.exports = __webpack_public_path__ + "img/SG.3272a961.webp";